import { render, staticRenderFns } from "./courseA.vue?vue&type=template&id=2281ce4a&scoped=true&"
import script from "./courseA.vue?vue&type=script&lang=js&"
export * from "./courseA.vue?vue&type=script&lang=js&"
import style0 from "./courseA.vue?vue&type=style&index=0&id=2281ce4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2281ce4a",
  null
  
)

export default component.exports